import { State } from "../../types";

// prettier-ignore
export const validStates = [
  // 50 US states and DC
  "AL","AK","AZ","AR","CA","CO","CT","DC","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
  // Canadian provinces and territories
  "AB","BC","MB","NB","NL","NT","NS","NU","ON","PE","QC","SK","YT",
] as const;

function assertState(possibleState?: unknown): asserts possibleState is State {
  if (typeof possibleState !== "string")
    throw new TypeError("State must be a string");

  if (!validStates.includes(possibleState as State))
    throw new TypeError(`Unknown state: ${possibleState}`);
}

export const validateState = (possibleState?: unknown): State => {
  assertState(possibleState);

  return possibleState;
};
